export default __webpack_public_path__ + "static/hammer_w.74f5b1327fc3da1fcc73c98f31dac0f1.svg";